import { createSliceDefinitions } from 'store/helpers/createSliceDefinitions';
import type { SliceCreator } from 'store/useAppStore.types';
import type { UISlice, UISliceState } from './UI.types';

const { actions } = createSliceDefinitions('UISlice', {
  SET_LOADING: 'setFullscreenLoading',
  RESET: 'reset',
});

const initialState: UISliceState = {
  fullscreenLoading: {
    isFullscreenLoading: false,
    fullscreenLoadingText: '',
  },
};

export const createUISlice: SliceCreator<UISlice> = (set) => ({
  ...initialState,

  actions: {
    setFullscreenLoading: (isLoading, loadingText) => {
      set(
        (state) => {
          state.UI.fullscreenLoading = {
            isFullscreenLoading: isLoading,
            fullscreenLoadingText: loadingText || '',
          };
        },
        false,
        { type: actions.SET_LOADING, payload: { isLoading, loadingText } },
      );
    },
    reset: () => {
      set(
        (state) => {
          state.UI = {
            ...state.UI,
            ...initialState,
          };
        },
        false,
        actions.RESET,
      );
    },
  },
});
